import * as StoreConstants from '@/modules/store/_model/constants';
import BaseHelpers from '@/plugins/baseHelpers';

/* Transforma os valores em informação amigável ao usuário */
const processStoreValues = (target, constant = undefined,) => {
  const processedData = JSON.parse(JSON.stringify(target,),);

  Object.keys(processedData,).forEach((processedDataKey,) => {
    switch (true) {
    /* Imagem padrão */
    case (processedDataKey === 'image' && !processedData[processedDataKey]):
      processedData[processedDataKey] = require('@/assets/logo-deliverymuch-black.svg',);
      break;
    /* Valor vazio */
    case ([null, '',].includes(processedData[processedDataKey],)):
      processedData[processedDataKey] = '-';
      break;
    /* Booleanos */
    case (typeof processedData[processedDataKey] === 'boolean'):
      processedData[processedDataKey] = processedData[processedDataKey] ? 'Sim' : 'Não';
      break;
    /* Objetos */
    case (BaseHelpers._toRawType(processedData[processedDataKey],) === 'Object'): {
      const partKey = processedDataKey.toUpperCase();
      const selectedKey = Object.keys(StoreConstants,).
        find((constantKey,) => constantKey.includes(partKey,),);
      processedData[processedDataKey] =
        processStoreValues(processedData[processedDataKey], StoreConstants[selectedKey],);
      break;
    }
    /* Constantes dentro de um objecto */
    case (
      !!constant &&
      !!processedDataKey &&
      !!constant[processedData[processedDataKey]]
    ):
      processedData[processedDataKey] = constant[processedData[processedDataKey]];
      break;
    /* Constantes na raiz do objecto */
    case (!!processedDataKey && !!StoreConstants[processedDataKey.toUpperCase()]): {
      const selectedConstant = StoreConstants[processedDataKey.toUpperCase()];
      processedData[processedDataKey] = selectedConstant[processedData[processedDataKey]];
      break;
    }
    default:
      break;
    }
  },);

  return processedData;
};

const document = (data, type,) => {
  const STATUS = StoreConstants[`${type}_STATUS`];

  const userData = data && data[`${type.toLowerCase()}_validation`];

  const available = data?.document_type_current === type;
  const hasNotAlreadyBeenValidated = !userData?.validation_id;
  const value = hasNotAlreadyBeenValidated ? 'NOT_REGISTERED' : userData?.status;
  const label = STATUS[value] || STATUS.NOT_REGISTERED;

  return {
    available,
    value,
    label,
    hasNotAlreadyBeenValidated,
  };
};

const storeFormat = {
  processStoreValues,
  document,
};

export {
  storeFormat,
};
